import { InjectionToken } from '@angular/core';

import { AiAssistantConfig } from './ai-assistant.types';

const DEFAULT_AI_ASSISTANT_CONFIG: AiAssistantConfig = {
	maxMemoryLines: 200,
	maxMemoryLength: 5000,
	baseUrl: 'https://api.openai.com/v1/realtime',
	retryAttempts: 3,
	retryDelay: 1000,
	debounceTime: 300,
};

export const AI_ASSISTANT_CONFIG = new InjectionToken<AiAssistantConfig>('AI_ASSISTANT_CONFIG', {
	factory: (): AiAssistantConfig => DEFAULT_AI_ASSISTANT_CONFIG,
});
